module.exports = __webpack_public_path__ + "static/about-staticLR-7a0f062d35c901491b3c3bca3ff91346.jpg";